export class AppSetting {
    ID: number;
    SettingKey: string;
    SettingValue: string;
}

export default AppSetting;